// export const SERVER_URL = "http://localhost:8080";
// export const SERVER_URL = "http://moradadamemoria2-env.eba-3czxxs9p.us-east-2.elasticbeanstalk.com/";
export const SERVER_URL = "https://moradadamemoria.com.br";
// export const FRONT_URL = "http://localhost:4200";
export const FRONT_URL = "https://painel.moradadamemoria.com.br";